<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';
import VueSweetalert2 from "vue-sweetalert2";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect
  },
  data() {
    return {
      errorMessage: "",
      title: "Airline Blocking Update",
      items: [
        {
          text: "Airline Blocking",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      agents: [],
      admins: [],
      airlines: [],
      vendors: [],
      roles: [],
      uuid: "",
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
        lineError:true,
      form: {
        is_allowed: "",
        is_ticketing_blocked: "",
        is_booking_blocked: "",
        is_search_blocked: "",
          account_type:"",
        is_active: "",
        user_role_id: "",
        user_id: "",
        origin: "",
        destination: "",
        airline_code: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      is_ticketing_blocked: {
        required,
      },
      is_booking_blocked: {
        required,
      },
      is_search_blocked: {
        required,
      },
      is_active: {
        required,
      },
      user_role_id: {
        required,
        numeric,
      },
      user_id: {
        required,
      },
        account_type: {
            required,
        },
      origin: {
        required,
        minLength: minLength(3),
      },
      destination: {
        required,
        minLength: minLength(3),
      },
      airline_code: {
        required,
        minLength: minLength(2),
      },
    },
  },

  created() {
    this.uuid = this.$route.params.uuid;
  },
  mounted() {
    this.getAirlineList();
    this.getRoleList();
    this.getAdminList();
    this.blockDetail();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    async getAdminList() {
      try {
        axios
          .get("/api/user/approved/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                let nullArr=[];
                nullArr.value=null;
                nullArr.text='all';
                arr.push(nullArr);
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                        if(temp[i].approved_agents[0].approval_status=='approved') {
                            temp[i].value = temp[i].id;
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            arr.push(temp[i]);
                        }
                    }
                    if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                        temp[i].value = temp[i].id;
                        temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                        arr.push(temp[i]);
                    }

                }
                this.admins = arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async blockDetail() {
      try {
        axios
          .post("/api/airline/block_detail/" + this.uuid, {
            accessToken: localStorage.getItem("access_tocken"),
          })
          .then((response) => {
            if (response.data.status) {
              var data = response.data.data;
              this.form.is_allowed = data.is_allowed,
              this.form.is_booking_blocked = data.is_booking_blocked,
              this.form.is_ticketing_blocked = data.is_ticketing_blocked,
              this.form.is_search_blocked = data.is_search_blocked,
              this.form.is_active = data.is_active,
              this.form.user_role_id = data.user_role_id,
              this.form.user_id = data.user_id==null ? null : parseInt(data.user_id),
              this.form.origin = data.origin,
              this.form.account_type=data.account_type,
              this.form.destination = data.destination,
              this.form.airline_code = data.airline_code
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getAirlineList() {
      try {
        axios
          .get("/api/airline/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                var temp=response.data.data;
                var i;
                for (i=0;i<temp.length;i++){
                    temp[i].value=temp[i].code;
                    temp[i].text=temp[i].name+' ('+temp[i].code+')';
                }
                this.airlines = temp;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getRoleList() {
      try {
        axios
          .get("/api/role_list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.roles = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      getRoleListOnChange(event) {
          var _that = this;
          try {
              axios
                  .get("/api/role/type", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                          type: event.target.value,
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          _that.roles = response.data.data;
                          _that.rolelist = [];
                          response.data.data.map(function(value, key) {
                              _that.rolelist[value.id] = value.type;
                          });
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          _that.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
      getUserOnChange(event) {
          var _that = this;
          try {
              axios
                  .get("/api/user/type", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                          type: this.rolelist[event.target.value],
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          let nullArr=[];
                          nullArr.value=null;
                          nullArr.text='all';
                          arr.push(nullArr);
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                              if(temp[i].account_type=='b2c' && temp[i].first_name != null){
                                  temp[i].value = temp[i].id;
                                  temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                  arr.push(temp[i]);
                              }

                          }
                          this.admins = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          _that.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    formSubmit(event) {
        if(this.form.account_type=='null'){
            this.form.account_type=null;
        }
        if(this.form.user_role_id=='null'){
            this.form.user_role_id=null;
        }
        if(this.form.user_id=='null'){
            this.form.user_id=null;
        }
      this.submitted = true;
      this.$v.$touch();
      axios
        .put("/api/airline/block_update", {
          uuid: this.uuid,
          is_allowed: this.form.is_allowed,
          is_ticketing_blocked: this.form.is_ticketing_blocked,
          is_booking_blocked: this.form.is_booking_blocked,
          is_search_blocked: this.form.is_search_blocked,
          is_active: this.form.is_active,
          user_id: this.form.user_id,
          user_role_id: this.form.user_role_id,
            account_type:this.form.account_type,
          origin: this.form.origin,
          destination: this.form.destination,
          airline_code: this.form.airline_code,
          created_by: localStorage.getItem("uuid"),
          updated_by: localStorage.getItem("uuid"),
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.blockingUpdateForm.reset();
            this.$swal("Good job!", "Airline Block Updated", "success");
            this.$router.push({ name: "block_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.lineError=false;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
    <Layout>
        <flashMessage/>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12 col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="errors" class="font-bold mb-4 ">
                            <div v-for="(v, k) in errors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </div>
                        </div>
                        <b-form class="needs-validation" ref="blockingUpdateForm" @submit.prevent="formSubmit">
                            <div class="row">
                                <!--                <div class="col-md-4">-->
                                <!--                  <div class="form-group">-->
                                <!--                    <label for="is_allowed">Allowed</label>-->
                                <!--                    <select-->
                                <!--                      id="is_allowed"-->
                                <!--                      name="is_allowed"-->
                                <!--                      v-model="form.is_allowed"-->
                                <!--                      class="form-control"-->
                                <!--                      :class="{ 'is-invalid': submitted && $v.form.is_allowed.$error }">-->
                                <!--                        <option value="" disabled style="display:none" selected>Select Allowed</option>-->
                                <!--                      <option value='1'>Yes</option>-->
                                <!--                      <option value='0'>No</option>-->
                                <!--                    </select>-->
                                <!--                    <div-->
                                <!--                      v-if="submitted && $v.form.is_allowed.$error"-->
                                <!--                      class="invalid-feedback"-->
                                <!--                    >-->
                                <!--                      <span v-if="!$v.form.is_allowed.required">This value is required.</span>-->
                                <!--                    </div>-->
                                <!--                  </div>-->
                                <!--                </div>-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="is_ticketing_blocked">Ticketing Block</label>
                                        <select
                                            id="is_ticketing_blocked"
                                            name="is_ticketing_blocked"
                                            v-model="form.is_ticketing_blocked"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_ticketing_blocked.$error }">
                                            <option value="" disabled style="display:none" selected>Select Ticketing Block</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_ticketing_blocked.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_ticketing_blocked.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="is_booking_blocked">Booking Block</label>
                                        <select
                                            id="is_booking_blocked"
                                            name="is_booking_blocked"
                                            v-model="form.is_booking_blocked"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_booking_blocked.$error }">
                                            <option value="" disabled style="display:none" selected>Booking Block</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_booking_blocked.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_booking_blocked.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="is_search_blocked">Search Block</label>
                                        <select
                                            id="is_search_blocked"
                                            name="is_search_blocked"
                                            v-model="form.is_search_blocked"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_search_blocked.$error }">
                                            <option value="" disabled style="display:none" selected>Select Search Block</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_search_blocked.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_search_blocked.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" for="is_active">Active</label>
                                        <select
                                            id="is_active"
                                            name="is_active"
                                            v-model="form.is_active"
                                            class="form-control"
                                            :class="{ 'is-invalid': submitted && $v.form.is_active.$error }">
                                            <option value="" disabled style="display:none" selected>Select Active</option>
                                            <option value='1'>Yes</option>
                                            <option value='0'>No</option>
                                        </select>
                                        <div
                                            v-if="submitted && $v.form.is_active.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.is_active.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="account_type">User Type</label>
                                        <select
                                            id="account_type"
                                            name="account_type"
                                            v-model="form.account_type"
                                            v-on:change="getRoleListOnChange"
                                            class="form-control"
                                            placeholder="Type User type"
                                        >
                                            <option value="" disabled style="display:none" selected>Select User Type</option>
                                            <option value="null">All</option>
                                            <option value="b2b">B2B</option>
                                            <option value="b2c">B2C</option>
                                        </select>
                                        <!--     <div
                                              v-if="submitted && $v.form.agent_type.$error"
                                              class="invalid-feedback"
                                            >
                                              <span v-if="!$v.form.agent_type.required">This value is required.</span>
                                            </div> -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="user_role_id">Select Role</label>
                                        <select
                                            id="user_role_id"
                                            name="user_role_id"
                                            v-model="form.user_role_id"
                                            class="form-control"
                                            v-on:change="getUserOnChange"
                                        >
                                            <option value="" disabled style="display:none" selected>Select Role</option>
                                            <option value="null">All</option>
                                            <option v-for="(role, index) in roles" :value="role.id"
                                                    v-bind:key="index">{{ role.name}}
                                            </option>
                                        </select>
                                        <!--                    <div-->
                                        <!--                      v-if="submitted && $v.form.user_role_id.$error"-->
                                        <!--                      class="invalid-feedback"-->
                                        <!--                    >-->
                                        <!--                      <span v-if="!$v.form.user_role_id.required">This value is required.</span>-->
                                        <!--                    </div>-->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Select User</label>
                                        <model-select :options="admins"
                                                      v-model="form.user_id"
                                                      placeholder="Select User">
                                        </model-select>
                                        <!--                    <div-->
                                        <!--                      v-if="submitted && $v.form.user_id.$error"-->
                                        <!--                      class="invalid-feedback"-->
                                        <!--                    >-->
                                        <!--                      <span v-if="!$v.form.user_id.required">This value is required.</span>-->
                                        <!--                    </div>-->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label class="required" >Airline Code</label>
                                        <model-select :options="airlines"
                                                      v-model="form.airline_code"
                                                      :class="{ 'is-invalid': submitted && $v.form.airline_code.$error}"
                                                      placeholder="Select Airline">
                                        </model-select>
                                        <div
                                            v-if="submitted && $v.form.airline_code.$error"
                                            class="invalid-feedback"
                                        >
                                            <span v-if="!$v.form.airline_code.required">This value is required.</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="origin">Origin</label>
                                        <input
                                            id="origin"
                                            v-model="form.origin"
                                            name="origin"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type origin name"
                                        />
                                        <!--                    <div-->
                                        <!--                      v-if="submitted && $v.form.origin.$error"-->
                                        <!--                      class="invalid-feedback"-->
                                        <!--                    >-->
                                        <!--                      <span v-if="!$v.form.origin.required">This value is required.</span>-->
                                        <!--                    </div>-->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="destination">Destination</label>
                                        <input
                                            id="destination"
                                            v-model="form.destination"
                                            name="destination"
                                            type="text"
                                            class="form-control"
                                            placeholder="Type Destination "
                                        />
                                        <!--                    <div-->
                                        <!--                      v-if="submitted && $v.form.destination.$error"-->
                                        <!--                      class="invalid-feedback"-->
                                        <!--                    >-->
                                        <!--                      <span v-if="!$v.form.destination.required">This value is required.</span>-->
                                        <!--                    </div>-->
                                    </div>
                                </div>

                            </div>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </b-form>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>
